// extracted by mini-css-extract-plugin
export var codeBlock = "alpaquita-containers-module--codeBlock--fcd3d";
export var description = "alpaquita-containers-module--description--de889";
export var faq = "alpaquita-containers-module--faq--d317c";
export var faqTable = "alpaquita-containers-module--faqTable--5bd3e";
export var img = "alpaquita-containers-module--img--30e42";
export var listBlock = "alpaquita-containers-module--listBlock--b2417";
export var listBlock2 = "alpaquita-containers-module--listBlock2--ef3ec";
export var listBlockHeading = "alpaquita-containers-module--listBlockHeading--90f6f";
export var logoHeading = "alpaquita-containers-module--logoHeading--17481";
export var logoHeadingIcon = "alpaquita-containers-module--logoHeadingIcon--22f74";
export var logoHeadingWrapper = "alpaquita-containers-module--logoHeadingWrapper--b784b";
export var logoLine = "alpaquita-containers-module--logoLine--8e1fb";
export var promo = "alpaquita-containers-module--promo--c9ae1";
export var table = "alpaquita-containers-module--table--dde62";
export var thead = "alpaquita-containers-module--thead--8e0c1";
export var title = "alpaquita-containers-module--title--abf30";
export var verticalLine = "alpaquita-containers-module--verticalLine--39a52";
export var whyParagraph = "alpaquita-containers-module--why-paragraph--ee9fe";